import { ApiRequest } from 'utils/ApiUtils';

const roleEndpoint = '/SysUser/Role';

class Role {
  constructor({ name, scopes }) {
    this.name = name;
    this.scopes = scopes;
  }

  static actions = Object.freeze({
    create: "create",
    read: "read",
    update: "update",
    delete: "delete"
  });

  check(scope, action) {
    try {
      if (action in Role.actions) {
        return this.scopes[scope].actions.includes(action.toLowerCase());
      } else {
        throw Role.errors.unknownAction
      }
    } catch (e) {
      if (!(scope in this.scopes)) {
        throw Role.errors.unknownScope
      };
      if (!(action in Role.actions)) {
        throw Role.errors.unknownAction
      }
      return false;
    }
  };

  static errors = {
    unknownScope: new Error('Unknown scope was passed to role check'),
    unknownAction: new Error('unknown action was passed to role check')
  }
}

class User {
  constructor({ Name, IsActive, SystemUserId, Title, UserName }) {
    this.name = Name;
    this.isActive = IsActive;
    this.systemUserId = SystemUserId;
    this.title = Title;
    this.userName = UserName
  }
};

async function getSysUserApi() {
  const data = await ApiRequest(roleEndpoint);
  if (data.success) {
    const role = new Role(data.roles);
    const user = new User(data.user);
    return [role, user];
  } else {
    throw Error("Unable to access application, please contact support.")
  }
};

export { getSysUserApi, Role, User };